(() => {
  const endpoint = 'https://zentrixa.co.uk/api/public/hair-referrals/event';
  const labels = JSON.parse(document.getElementById('zg-referral-labels')?.textContent || '{}');
  const normalise = value => /^[a-f0-9]{16}$/i.test(String(value || '').trim()) ? String(value).trim().toUpperCase() : '';
  let code = normalise(new URL(location.href).searchParams.get('ref'));
  let sessionId = crypto.randomUUID();
  if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
    try {
      sessionId = sessionStorage.getItem('zg_referral_session') || sessionId;
      sessionStorage.setItem('zg_referral_session', sessionId);
    } catch {}
  }
  const api = async (action, payload) => {
    if (action === 'validate' && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return {deferred: true};
    const response = await fetch(endpoint, {method: 'POST', credentials: 'omit', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({kind: action === 'validate' ? 'visit' : action, ...payload, session_id: sessionId}), keepalive: true});
    if (!response.ok) throw new Error('Referral request unavailable');
    return response.json();
  };
  const decorate = link => {
    if (!link || !code || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol) || /^\/(account|customer_authentication)/.test(url.pathname)) return;
    if (url.pathname === location.pathname && url.hash) return;
    url.searchParams.set('ref', code);
    link.href = url.href;
  };
  const decorateLinks = () => document.querySelectorAll('a[href]').forEach(decorate);
  const setCode = value => {code = normalise(value); decorateLinks();};
  decorateLinks();
  document.addEventListener('click', event => decorate(event.target.closest('a[href]')), true);
  document.addEventListener('auxclick', event => decorate(event.target.closest('a[href]')), true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-referral-basket]');
    if (!link || !code) return;
    link.dataset.referralRequest ||= crypto.randomUUID();
    const requestId = link.dataset.referralRequest;
    const url = new URL(link.href);
    const original = link.dataset.originalMessage ||= url.searchParams.get('text') || '';
    url.searchParams.set('text', `${original}\n${labels.code_message}: ${code}\n${labels.reference}: ${requestId}`);
    link.href = url.href;
    api('enquiry', {
      request_id: requestId, referral_code: code, product_id: 'basket', variant_id: 'basket',
      product_title: `Shop basket (${link.dataset.itemCount} items)`, variant_title: '', quantity: 1,
      product_url: `${location.origin}/cart`, quoted_total_ghs: Number(link.dataset.quotedTotal)
    }).catch(() => {});
  }, true);
  window.ghanaReferrals = {getCode: () => code, setCode, normalise, labels, api, requestId: () => crypto.randomUUID()};
  let tracked = false;
  const track = () => {
    if (tracked || !code || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    tracked = true;
    try {
      sessionId = sessionStorage.getItem('zg_referral_session') || sessionId;
      sessionStorage.setItem('zg_referral_session', sessionId);
    } catch {}
    api('visit', {referral_code: code, session_id: sessionId}).catch(() => {});
  };
  track();
  document.addEventListener('visitorConsentCollected', track);
})();
